import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const googleDriveManifest: FeatureManifest = {
  id: 'resource-google-drive',
  path: 'resources/google-drive/*',
  navPath: '/resources/google-drive',
  label: 'Google Drive',
  description: 'Quản lý tài khoản Google Drive dùng để lưu trữ tài nguyên',
  navigationGroup: { id: 'resources', label: 'Quản lý tài nguyên' },
  load: () => import('./entry'),
}
